import { BANK_PAYMENT_RETURN_REQUEST, GET_BANK_PAYMENT_RETURNS, CREATE_BANK_PAYMENT_RETURN, UPDATE_BANK_PAYMENT_RETURN, DELETE_BANK_PAYMENT_RETURN,
  BANK_PAYMENT_RETURN_REQUEST_FAILURE, BANK_PAYMENT_RETURN_REQUEST_SUCCESS } from '../types';

const initialState = {
  bankPaymentReturns: [],
  loading: false,
  error: null,
};

const bankPaymentReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENT_RETURNS: {
      return {
        ...state,
        bankPaymentReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_PAYMENT_RETURN: {
      return {
        ...state,
        bankPaymentReturns: [action.payload, ...state.bankPaymentReturns],
        loading: false,
        error: null
      };
    }
    case UPDATE_BANK_PAYMENT_RETURN: {
      const bankPaymentReturnsData = state.bankPaymentReturns.slice(0);
      const uIndex = bankPaymentReturnsData.findIndex((data) => data.id === action.payload.id);
      bankPaymentReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankPaymentReturns: [ ...bankPaymentReturnsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_BANK_PAYMENT_RETURN: {
      const bankPaymentReturns = state.bankPaymentReturns?.slice(0);
      const index = bankPaymentReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankPaymentReturns.splice(index, 1);
      }
      return {
        ...state,
        bankPaymentReturns: [...bankPaymentReturns],
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_RETURN_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentReturnReducer;